import { Component } from '@angular/core';
import { ViewController, Events, NavParams } from 'ionic-angular';

@Component({
  selector: 'speech-input-popover',
  templateUrl: 'speech-input.html'
})


export class SpeechInputPopover {

  segment: any;
  results: any;
  element: any;
  finalText: any;
  recording: boolean = false;
  recognition: any;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public events: Events) {
  }

  ionViewDidLoad() {
    this.element = this.navParams.get('element');
    this.finalText = this.element.DisplayText;
    this.segment = 'record';
    this.results = [];
  }

  finish() {
    this.events.publish('inputs:speechinput', this.finalText, this.element);
    this.viewCtrl.dismiss();
  }

  cancel() {
    this.viewCtrl.dismiss();
  }

  setTextToVariant(newText) {
    if (newText != undefined) {
      this.finalText = newText;
    }
    this.segment = 'record';
  }

  startSpeechToText() {
    if (!this.recording) {
      let speechRecognition = window['webkitSpeechRecognition'];
      this.recognition = new speechRecognition();

      this.recognition.continuous = false;
      this.recognition.lang = 'de-DE';
      this.recognition.maxAlternatives = 10000;
      this.recognition.onresult = this.onResultCall.bind(this);
      this.recognition.onend = this.onEndCall.bind(this);
      this.recognition.onstart = this.onStartCall;
      this.recognition.start();
    } else {
      this.recognition.stop();
    }
    this.recording = !this.recording;
  }

  onEndCall() {
    console.log('Stop recognition');

    this.recording = false;
  }

  onStartCall() {
    console.log("Start recognition");
  }

  onResultCall(event) {
    console.log('got result', event);
    let result = event.results[0]
    this.results = [];
    for (let i = 0; i < result.length; i++) {
      this.results.push(result[i]['transcript'])
    }
    this.finalText = this.results[0]; // best confidence
    console.log(this.results);
  }
}



// WEBPACK FOOTER //
// ./src/popovers/speech-input/speech-input.ts